{
  "GENERAL_SETTINGS": {
    "LIMIT_MESSAGES": {
      "CONVERSATION": "Du har overskredet samtalegrensen. Hacker-planen tillater bare 500 samtaler.",
      "INBOXES": "Du har overskredet innboksgrensen. Hacker-planen støtter bare live chat på nettsted. Flere innbokser som e-post, WhatsApp osv. krever en betalt plan.",
      "AGENTS": "Du har overskredet agentgrensen. Hacker-planen tillater bare 2 agenter.",
      "NON_ADMIN": "Kontakt administratoren din for å oppgradere planen og fortsette å bruke alle funksjonene."
    },
    "TITLE": "Kontoinnstillinger",
    "SUBMIT": "Oppdater innstillinger",
    "BACK": "Tilbake",
    "DISMISS": "Dismiss",
    "UPDATE": {
      "ERROR": "Kunne ikke oppdatere innstillinger, prøv igjen!",
      "SUCCESS": "Innstillinger ble oppdatert"
    },
    "ACCOUNT_DELETE_SECTION": {
      "TITLE": "Slett kontoen din",
      "NOTE": "Når du sletter kontoen din, blir alle dataene dine slettet.",
      "BUTTON_TEXT": "Slett kontoen din",
      "CONFIRM": {
        "TITLE": "Slett konto",
        "MESSAGE": "Sletting av kontoen din kan ikke angres. Skriv inn kontonavnet ditt nedenfor for å bekrefte at du vil slette den permanent.",
        "BUTTON_TEXT": "Slett",
        "DISMISS": "Avbryt",
        "PLACE_HOLDER": "Skriv {accountName} for å bekrefte"
      },
      "SUCCESS": "Kontoen er markert for sletting",
      "FAILURE": "Kunne ikke slette kontoen, prøv igjen!",
      "SCHEDULED_DELETION": {
        "MESSAGE_MANUAL": "Denne kontoen er planlagt slettet {deletionDate}. Dette ble forespurt av en administrator. Du kan avbryte slettingen før denne datoen.",
        "MESSAGE_INACTIVITY": "Denne kontoen er planlagt slettet {deletionDate} på grunn av inaktivitet. Du kan avbryte slettingen før denne datoen.",
        "CLEAR_BUTTON": "Avbryt planlagt sletting"
      }
    },
    "FORM": {
      "ERROR": "Vennligst fiks skjemafeil",
      "GENERAL_SECTION": {
        "TITLE": "Generelle innstillinger",
        "NOTE": ""
      },
      "ACCOUNT_ID": {
        "TITLE": "Account ID",
        "NOTE": "This ID is required if you are building an API based integration"
      },
      "NAME": {
        "LABEL": "Kontonavn",
        "PLACEHOLDER": "Ditt kontonavn",
        "ERROR": "Vennligst oppgi et gyldig kontonavn"
      },
      "LANGUAGE": {
        "LABEL": "Site language",
        "PLACEHOLDER": "Ditt kontonavn",
        "ERROR": ""
      },
      "DOMAIN": {
        "LABEL": "Innkommende e-postdomene",
        "PLACEHOLDER": "Domenet hvor du vil motta e-posten",
        "ERROR": ""
      },
      "SUPPORT_EMAIL": {
        "LABEL": "Support e-post",
        "PLACEHOLDER": "Ditt firmas support e-post",
        "ERROR": ""
      },
      "AUTO_RESOLVE_DURATION": {
        "LABEL": "Antall dager en sak skal løses automatisk hvis det ikke har vært aktivitet",
        "NOTE": "Antall timer med inaktivitet før en åpen samtale automatisk løses.",
        "PLACEHOLDER": "30",
        "ERROR": "Please enter a valid auto resolve duration (minimum 1 day and maximum 999 days)"
      },
      "AUTO_RESOLVE_EMPTY_DURATION": {
        "LABEL": "Antall dager før en tom samtale automatisk løses hvis det ikke er noen aktivitet",
        "PLACEHOLDER": "aldri",
        "ERROR": "Skriv inn en gyldig varighet for automatisk løsing av tomme samtaler (minimum 1 dag og maksimum 999 dager)"
      },
      "FEATURES": {
        "INBOUND_EMAIL_ENABLED": "Samtalekontinuitet med e-post er aktivert for din konto.",
        "CUSTOM_EMAIL_DOMAIN_ENABLED": "Du kan motta e-post i ditt egendefinerte domene nå."
      },
      "PHONE": {
        "TITLE": "PBX-innstillinger",
        "NOTE": "Konfigurer tilkoblingen til PBX-en din for telefonsamtaler",
        "SIP_HOST": {
          "LABEL": "SIP-domene"
        },
        "DIALING_MODE": {
          "LABEL": "Ringemodus",
          "MODES": {
            "direct": "Direkte - samtalen ringes umiddelbart når du klikker på telefonlenken",
            "indirect": "Indirekte - telefonnummeret klargjøres i telefonwidgetens innskrivingsfelt"
          }
        },
        "CALL_RECORDING_ACCESS": {
          "LABEL": "Tilgang til samtaleopptak",
          "MODES": {
            "admin_only": "Kun administratorer",
            "admin_and_assigned_agent": "Administratorer og tildelt agent",
            "inbox_members": "Alle agenter med tilgang til innboksen"
          }
        }
      },
      "EMAIL": {
        "TITLE": "E-postinnstillinger",
        "NOTE": "Endrer oppførselen til e-postinnbokser"
      },
      "CONVERSATION_TIMESTAMP_DISPLAY_MODE": {
        "LABEL": "Visningsmodus for tidsstempel i samtaler",
        "MODES": {
          "both": "Opprettet og siste aktivitet",
          "last_activity_only": "Kun siste aktivitet",
          "last_customer_message": "Siste kundemelding"
        }
      },
      "BLOCK_DOMAINS_WITH_LOW_REPUTATION": {
        "LABEL": "Blokker domener med lavt omdømme"
      },
      "INCLUDE_PREVIOUS_EMAIL_MESSAGE": {
        "LABEL": "Inkluder den opprinnelige meldingen i svaret på e-posten"
      },
      "RESOLVE_NEW_CONVERSATION": {
        "LABEL": "Løs en ny samtale automatisk"
      },
      "MOVE_CONVERSATIONS_BY_ORDERS": {
        "LABEL": "Flytt automatisk en ny e-postsamtale til innboksen til roboten som behandlet kontaktens bestillinger"
      },
      "EXTENDED_LABELS": {
        "LABEL": "Utvidede etiketter - Tillat lengre etikettnavn med et større popup-grensesnitt"
      },
      "ENABLE_LAST_AGENT": {
        "LABEL": "LastAgent - Tildel automatisk samtalen til agenten som ga det siste svaret"
      },
      "PUSH_NOTIFICATION_MODE": {
        "LABEL": "Modus for push-varsler",
        "MODES": {
          "all_inboxes": "Alle innbokser - Send varsler for alle kanaltyper",
          "chat_only": "Kun chat - Send bare varsler for kanaler som ikke er e-post"
        }
      },
      "ALLOW_TOGGLE_SIGNATURE": {
        "LABEL": "Tillat av/på-bryter for signatur på sendte meldinger"
      },
      "WALLBOARD_CHAT_STATUS_ENABLED": {
        "LABEL": "Vis agenters chattestatus på wallboardet"
      },
      "SHOW_FULL_ATTACHMENT_NAMES": {
        "LABEL": "Vis fullstendige filnavn på vedlegg uten forkorting"
      },
      "PASSWORD_LOGIN_MODE": {
        "LABEL": "Innlogging med passord",
        "MODES": {
          "allowed_for_all": "Tillatt for alle brukere",
          "allowed_for_agents_only": "Kun tillatt for agenter (administratorer må bruke OAuth)",
          "password_login_disabled": "Deaktivert - kun OAuth"
        }
      }
    },
    "NEW_VERSION_AVAILABLE": "En ny versjon er tilgjengelig. Last inn på nytt for å få de siste oppdateringene.",
    "RELOAD_NOW": "Oppdater nå",
    "LEARN_MORE": "Learn more",
    "PAYMENT_PENDING": "Betalingen din venter. Oppdater betalingsinformasjonen din for å fortsette å bruke denne programvaren",
    "LIMITS_UPGRADE": "Kontoen din har overskredet bruksgrensene. Oppgrader planen din for å fortsette å bruke denne programvaren",
    "OPEN_BILLING": "Open billing"
  },
  "FORMS": {
    "MULTISELECT": {
      "ENTER_TO_SELECT": "Trykk enter for å velge",
      "ENTER_TO_REMOVE": "Trykk enter for å fjerne",
      "NO_OPTIONS": "Listen er tom",
      "NO_RESULT": "Ingen resultater funnet",
      "SELECT_ONE": "Velg en",
      "SELECT": "Velg"
    }
  },
  "NOTIFICATIONS_PAGE": {
    "HEADER": "Varsler",
    "MARK_ALL_DONE": "Merk alle som ferdige",
    "DELETE_TITLE": "deleted",
    "UNREAD_NOTIFICATION": {
      "TITLE": "Unread Notifications",
      "ALL_NOTIFICATIONS": "View all notifications",
      "LOADING_UNREAD_MESSAGE": "Loading unread notifications...",
      "EMPTY_MESSAGE": "You have no unread notifications"
    },
    "LIST": {
      "LOADING_MESSAGE": "Laster varsler...",
      "404": "Ingen varsler",
      "TABLE_HEADER": [
        "Navn",
        "Telefonnummer",
        "Samtaler",
        "Siste kontakt"
      ]
    },
    "TYPE_LABEL": {
      "conversation_creation": "Ny samtale",
      "conversation_assignment": "Samtale tildelt",
      "assigned_conversation_new_message": "Ny melding",
      "participating_conversation_new_message": "Ny melding",
      "conversation_mention": "Omtale",
      "sla_missed_first_response": "SLA Missed",
      "sla_missed_next_response": "SLA Missed",
      "sla_missed_resolution": "SLA Missed"
    }
  },
  "NETWORK": {
    "NOTIFICATION": {
      "OFFLINE": "Frakoblet",
      "RECONNECTING": "Reconnecting...",
      "RECONNECT_SUCCESS": "Reconnected"
    },
    "BUTTON": {
      "REFRESH": "Refresh"
    },
    "CONNECTION_LOST": {
      "TITLE": "Tilkobling mistet",
      "DESCRIPTION": "Vi kunne ikke nå serveren. Sjekk tilkoblingen din og prøv igjen.",
      "RETRY": "Prøv igjen"
    }
  },
  "COMMAND_BAR": {
    "SEARCH_PLACEHOLDER": "Search or jump to",
    "SECTIONS": {
      "GENERAL": "General",
      "REPORTS": "Rapporter",
      "CONVERSATION": "Conversation",
      "BULK_ACTIONS": "Bulk Actions",
      "CHANGE_ASSIGNEE": "Change Assignee",
      "CHANGE_PRIORITY": "Change Priority",
      "CHANGE_TEAM": "Change Team",
      "SNOOZE_CONVERSATION": "Snooze Conversation",
      "EXECUTE_MACRO": "Kjør makro",
      "ADD_LABEL": "Add label to the conversation",
      "REMOVE_LABEL": "Remove label from the conversation",
      "SETTINGS": "Innstillinger",
      "AI_ASSIST": "AI Assist",
      "APPEARANCE": "Appearance",
      "SNOOZE_NOTIFICATION": "Snooze Notification"
    },
    "COMMANDS": {
      "GO_TO_CONVERSATION_DASHBOARD": "Go to Conversation Dashboard",
      "GO_TO_CONTACTS_DASHBOARD": "Go to Contacts Dashboard",
      "GO_TO_REPORTS_OVERVIEW": "Go to Reports Overview",
      "GO_TO_CONVERSATION_REPORTS": "Go to Conversation Reports",
      "GO_TO_AGENT_REPORTS": "Go to Agent Reports",
      "GO_TO_LABEL_REPORTS": "Go to Label Reports",
      "GO_TO_INBOX_REPORTS": "Go to Inbox Reports",
      "GO_TO_TEAM_REPORTS": "Go to Team Reports",
      "GO_TO_SETTINGS_AGENTS": "Go to Agent Settings",
      "GO_TO_SETTINGS_TEAMS": "Go to Team Settings",
      "GO_TO_SETTINGS_INBOXES": "Go to Inbox Settings",
      "GO_TO_SETTINGS_LABELS": "Go to Label Settings",
      "GO_TO_SETTINGS_CANNED_RESPONSES": "Go to Canned Response Settings",
      "GO_TO_SETTINGS_APPLICATIONS": "Go to Application Settings",
      "GO_TO_SETTINGS_ACCOUNT": "Go to Account Settings",
      "GO_TO_SETTINGS_PROFILE": "Go to Profile Settings",
      "GO_TO_NOTIFICATIONS": "Go to Notifications",
      "ADD_LABELS_TO_CONVERSATION": "Add label to the conversation",
      "ASSIGN_AN_AGENT": "Assign an agent",
      "AI_ASSIST": "AI Assist",
      "ASSIGN_PRIORITY": "Assign priority",
      "ASSIGN_A_TEAM": "Assign a team",
      "EXECUTE_A_MACRO": "Kjør en makro",
      "MUTE_CONVERSATION": "Mute conversation",
      "UNMUTE_CONVERSATION": "Unmute conversation",
      "REMOVE_LABEL_FROM_CONVERSATION": "Remove label from the conversation",
      "REOPEN_CONVERSATION": "Reopen conversation",
      "RESOLVE_CONVERSATION": "Resolve conversation",
      "SEND_TRANSCRIPT": "Send an email transcript",
      "SNOOZE_CONVERSATION": "Snooze Conversation",
      "UNTIL_NEXT_REPLY": "Until next reply",
      "UNTIL_NEXT_WEEK": "Until next week",
      "UNTIL_TOMORROW": "Until tomorrow",
      "UNTIL_NEXT_MONTH": "Until next month",
      "AN_HOUR_FROM_NOW": "Until an hour from now",
      "UNTIL_CUSTOM_TIME": "Custom...",
      "CHANGE_APPEARANCE": "Change Appearance",
      "LIGHT_MODE": "Light",
      "DARK_MODE": "Dark",
      "SYSTEM_MODE": "System",
      "SNOOZE_NOTIFICATION": "Snooze Notification"
    }
  },
  "DASHBOARD_APPS": {
    "LOADING_MESSAGE": "Loading Dashboard App..."
  },
  "COMMON": {
    "OR": "Or",
    "CLICK_HERE": "klikk her"
  }
}
